<router-outlet></router-outlet>

<div class="idcar-spinner" *ngIf="isSync">
    <div class="spinner-text-container">
        <mat-spinner color="primary" diameter="50"></mat-spinner>
        <div class="spinner-text">{{ 'text_sync_in_progress' | translate }}</div>
    </div>
</div>

